// ─────────────────────────────────────────────────────────────────
// Phase C — Bloc dashboard "Plans d'analyses à suivre"
// Date : 2026-05-10
//
// Compteur agrege par statut, visible dans AnissaDashboard juste
// au-dessus de "Mes clients". Donne a Anissa une vue 1 coup d'oeil
// du flux d'analyses en cours.
//
// V4 minimal : juste les 4 chiffres, pas de liste cliquable. Les
// transitions de statut se font dans la fiche cliente (AnalysisPlanCard).
// Si un chiffre devient utile a "drill", on ajoutera plus tard.
// ─────────────────────────────────────────────────────────────────

import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';

export default function AnalysisPlansFollowupBlock() {
  const [counts, setCounts] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString();
      const { data, error } = await supabase
        .from('analysis_plans')
        .select('status, updated_at');
      if (cancelled) return;
      if (error) {
        // pas de bloc si erreur (silencieux : ne pas polluer le dashboard)
        setLoading(false);
        return;
      }
      const c = { draft: 0, sent: 0, in_progress: 0, completed_recent: 0 };
      (data || []).forEach((p) => {
        if (p.status === 'draft') c.draft++;
        else if (p.status === 'sent') c.sent++;
        else if (p.status === 'in_progress') c.in_progress++;
        else if (p.status === 'completed' && p.updated_at && p.updated_at >= sevenDaysAgo) {
          c.completed_recent++;
        }
      });
      setCounts(c);
      setLoading(false);
    }
    load();
    return () => { cancelled = true; };
  }, []);

  if (loading || !counts) return null;
  const totalActive = counts.draft + counts.sent + counts.in_progress;
  if (totalActive === 0 && counts.completed_recent === 0) return null;

  return (
    <section className="attention-card analysis-followup">
      <div className="analysis-followup__header">
        <span className="analysis-followup__title">Plans d'analyses à suivre</span>
        <span className="analysis-followup__total">
          {totalActive} {totalActive > 1 ? 'plans actifs' : 'plan actif'}
        </span>
      </div>
      <div className="analysis-followup__counts">
        <Counter value={counts.draft} label="Brouillons" color="#5f6b62" />
        <Counter value={counts.sent} label="Envoyés" color="#2f6a43" />
        <Counter value={counts.in_progress} label="Résultats reçus" color="#94691f" />
        <Counter value={counts.completed_recent} label="Terminés (7j)" color="#2f6a43" />
      </div>
    </section>
  );
}

function Counter({ value, label, color }) {
  return (
    <div className="analysis-followup__counter">
      <div className="analysis-followup__value" style={{ color }}>{value}</div>
      <div className="analysis-followup__label">
        {label}
      </div>
    </div>
  );
}
